import SeoMetaData from "common/SeoMetaData"
import {
  StaticPropsFactory,
  StaticPropsFactoryProps,
} from "common/StaticPropsFactory"
import dynamic from "next/dynamic"

const TermsOfUseMarkdown = dynamic(() => import("docs/terms-of-use.mdx"), {
  ssr: false,
  loading: () => <div>Loading...</div>,
})

export const getStaticProps = StaticPropsFactory("termsOfUse")

export default function TermsOfUse({ seo }: StaticPropsFactoryProps) {
  return (
    <>
      <SeoMetaData data={seo} />
      <TermsOfUseMarkdown />
    </>
  )
}
